<template>
    <div class="page-wrapper">
        <page-header :title="$t('privateProfile.profilePictures')" />
        <ion-text class="w-100 ion-padding-start ion-padding-end" color="dark">
            <b>{{ $t('privateProfile.changeProfilePictures') }}</b>
        </ion-text>
        <ion-grid>
            <ion-row>
                <ion-col size="6">
                    <uploader
                        ref="main"
                        path="/profile-picture"
                        v-if="imagesLoaded"
                        :defaultImgPath="userImages[0] && userImages[0].path"
                        position="0"
                    />
                </ion-col>
                <ion-col size="6">
                    <uploader
                        path="/profile-picture"
                        v-if="imagesLoaded"
                        :defaultImgPath="userImages[1] && userImages[1].path"
                        position="1"
                    />
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6">
                    <uploader
                        path="/profile-picture"
                        v-if="imagesLoaded"
                        :defaultImgPath="userImages[2] && userImages[2].path"
                        position="2"
                    />
                </ion-col>
                <ion-col size="6">
                    <uploader
                        path="/profile-picture"
                        v-if="imagesLoaded"
                        :defaultImgPath="userImages[3] && userImages[3].path"
                        position="3"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-row>
            <router-link to="/user/me">
                <ion-button class="back-button" color="primary" strong>
                    <img class="back-arrow icon-img-xs" src="@/assets/icon-images/arrow-left-white.png" />
                    {{ $t('master.back') }}
                </ion-button>
            </router-link>
        </ion-row>
    </div>
</template>

<script>
import Uploader from '@/components/Uploader'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'

export default {
    name: 'EditProfilePictures',
    components: {
        Uploader,
        PageHeader
    },
    data() {
        return {
            userImages: [],
            imagesLoaded: false,
            imageSlots: [],
            newPath: null
        }
    },
    computed: mapGetters(['user']),
    mounted() {
        this.user.images.forEach((image, key) => {
            this.imageSlots[key] = this.user.images[key].position
            this.userImages[this.imageSlots[key]] = this.user.images[key]
        })
        this.imagesLoaded = true
    }
}
</script>

<style lang="scss" scoped>
.back-button {
    height: 35px;
    padding-left: 15px;
    --border-radius: 20px;
    margin-top: 10px;
    --color: #000000;
}

.w-100 {
    width: 100%;
    max-width: 100%;
    display: inline-block;
}

#app[dir='rtl'] .back-arrow {
    transform: rotate(180deg);
}

@media (min-width: 768px) {
    .page-wrapper {
        width: 80%;
        margin: 0 10%;

        ion-text {
            font-size: 20px;

            .header-text {
                margin-top: 22px;
            }
        }

        ion-grid {
            width: 70%;

            ion-row {
                margin-top: 15px;
            }
        }
    }
}
</style>
